<main id="main-content" tabindex="-1">
  <div class="max-h-fit px-0 md:px-4 lg:px-20 pt-10">
    <div class="grid grid-cols-2 py-5">
      <div class="col-span-2 lg:col-span-1 items-center pb-4">
        <h1 class="text-dark-purple text-3xl font-bold">Users</h1>
      </div>
      <div class="col-span-2 pb-4 flex flex-col md:flex-row md:justify-end gap-3">
        <prism-btn
          btnClass="bg-white text-dark-purple font-bold border-2 p-0 m-0 rounded-xl border-dark-purple"
          [routerLink]="['/user-add']"
          (keydown.enter)="router.navigate(['/user-add'])">
          <i class="uil uil-plus text-dark-purple font-bold pr-1"></i>
          Add User(s)
        </prism-btn>
        <prism-btn
          btnClass="bg-white text-dark-purple font-bold border-2 p-0 m-0 rounded-xl border-dark-purple"
          (click)="downloadReport()"
          [disabled]="!data.length">
          <i class="uil uil-import text-dark-purple font-bold pr-1"></i>
          Download
        </prism-btn>
      </div>
      <div class="col-span-2 flex flex-col lg:flex-row gap-4 pb-4">
        <div class="w-full lg:w-5/12">
          <prism-input inputType="text" [control]="search" [required]="false"
            placeHolder="Search for name, email, user type, etc..." [hasSearch]="true" (search)="searchUsers()">
          </prism-input>
        </div>
        <div class="w-full lg:w-3/12">
          <prism-select-role [control]="searchRoleId" [required]="false" [readOnly]="isUser">
          </prism-select-role>
        </div>
        <div class="w-full lg:w-4/12">
          <prism-select-organization [control]="organizationId" [required]="false" [readOnly]="isUser">
          </prism-select-organization>
        </div>
      </div>

    </div>

    <prism-table [columns]="columns" [colHeaders]="colHeaders" [tableData]="data" [isDelete]="true" [isEdit]="true"
      [pageIndex]="pageIndex" [pageSize]="pageSize" [totalData]="totalData" (edit)="editUser($event)"
      (pageIndexChange)="handlePageIndexChange($event)" (pageSizeChange)="handlePageSizeChange($event)"
      (columnDirectionChange)="handleColumnDirectionChange($event)" (delete)="deleteUser($event)" (passwordReset)="resetUserPassword($event)">
    </prism-table>
  </div>
</main>

<nz-modal [(nzVisible)]="isVisible" [nzTitle]="modalTitle" nzWidth="800px" [nzBodyStyle]="{'height':'auto'}"
  (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()" [nzOkDisabled]="isEditModalSubmitting">
  <ng-container *nzModalContent>
    <form class="grid grid-cols-2 gap-x-4" [formGroup]="userForm">

      <div class="col-span-2 lg:col-span-1 items-center w-[100%] pb-4">
        <prism-input [control]="firstName" placeHolder="Enter first name" label="First Name" [required]="true"
          inputType="text" [maxLength]="50">
        </prism-input>
      </div>

      <div class="col-span-2 lg:col-span-1 items-center w-[100%] pb-4">
        <prism-input [control]="lastName" placeHolder="Enter last name" label="Last Name" [required]="true"
          inputType="text" [maxLength]="50">
        </prism-input>
      </div>

      <div class="col-span-2 lg:col-span-1 items-center w-[100%] pb-4">
        <prism-input [control]="emailName" placeHolder="Enter email" label="Email" [required]="true" inputType="email">
        </prism-input>
      </div>

      <div class="col-span-2 lg:col-span-1 items-center w-[100%] pb-4">
        <prism-select-role [control]="roleId" label="Roles" [required]="roleId?.value !== roles.SystemAdmin">
        </prism-select-role>
      </div>

      @if (roleId?.value == roles.User) {
      <div class="col-span-2 lg:col-span-1 items-center w-[100%] pb-4">
        <prism-select-grade [control]="gradeIds" label="Grade Level" [required]="true" [multiSelect]="true">
        </prism-select-grade>
      </div>
      }

      @if(roleId?.value !== roles.SystemAdmin) {
      <div class="col-span-2 lg:col-span-1 items-center w-[100%] pb-4">
        <prism-select-organization [control]="districtId" label="District" [required]="true" [readOnly]="isUser"
          [multiSelect]="roleId?.value !== roles.User">
        </prism-select-organization>
      </div>
      }

      @if (roleId?.value === roles.User) {
      <div class="col-span-2 lg:col-span-1 items-center w-[100%] pb-4">
        <prism-select-school [control]="schoolId" [districtId]="districtId?.value" label="School" [required]="true">
        </prism-select-school>
      </div>
      }
    </form>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="isPasswordResetVisible"
          [nzTitle]="modalTitle"
          nzWidth="800px"
          [nzBodyStyle]="{'height':'auto'}"
          (nzOnCancel)="handleCancelPassword()"
          [nzOkDisabled]="true"
          [nzFooter]="null"
          [nzBodyStyle]="{ height: 'auto', paddingTop: '5px' }">
  <ng-container *nzModalContent>
    <prism-reset-password-form
      [buttonLabel]="'Reset Password'"
      (submitted)="submitAdminReset($event)">
    </prism-reset-password-form>
  </ng-container>
</nz-modal>
